const mutations = {
  setModels(state, data) {
    state.cursados = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.cursado = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.cursados.unshift(model);
  },
  addModels(state, models) {
    state.record.nuevo = true;
    state.cursados.concat(models);
  },

  updateModel(state, model) {
    const index = state.cursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.cursados.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.cursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.cursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
